import React from "react";
import PropTypes from "prop-types";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import { crunchClasses } from "@cayuse/shared-react.utils.helpers";

import styles from "./index.css";

export const Card = ({ children, className, title, ...rest }) => {
	const cardClasses = crunchClasses({
		[styles.cardContainer]: true,
		[className]: isNonEmptyString(className)
	});

	const renderTitle = () => {
		if(title) {
			return (
				<div className={styles.title}>
					<h3>{title}</h3>
				</div>
			);
		}
	};

	return (
		<div className={cardClasses} {...rest}>
			{renderTitle()}
			<div className={styles.values}>
			  {children}
			</div>
		</div>
	);
};

Card.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	title: PropTypes.string
};

export default Card;